import { NonUndefined } from 'tsdef';
import { useAppDispatch } from '../../app/hooks';
import { saveKingBaitQualityAsync, UserInitialState } from '../user/userSlice';

export const useSaveKingBaitQuality = () => {
  const dispatch = useAppDispatch();
  return (quality: NonUndefined<UserInitialState['kingBait']>['quality']) =>
    dispatch(saveKingBaitQualityAsync(quality));
};
